import {CommonGroupProps} from '../../type';

/**
 * 아무 조작 없이 children을 그대로 보여준다.
 */
export function PassChildren({children}: CommonGroupProps) {
  return <>{children}</>;
}
